// Default institutional protocol (PSD §3.2 InstitutionalProtocol / TODO Task 0.4)
import { Agent, NomogramSource, type InstitutionalProtocol } from '@/types';
import { BORDERLINE_BAND_ML_MIN, HARTFORD_WINDOW_HR } from './constants';

export const DEFAULT_PROTOCOL: InstitutionalProtocol = {
  renalCutoffMlMin: 20,
  defaultNomogram: NomogramSource.Hartford,
  doseRanges: {
    [Agent.Gentamicin]: { min: 5, max: 7 },
    [Agent.Tobramycin]: { min: 5, max: 7 },
    [Agent.Amikacin]: { min: 15, max: 15 },
    [Agent.Plazomicin]: { min: 7.5, max: 7.5 },
  },
  roundingIncrements: {
    [Agent.Gentamicin]: 20,
    [Agent.Tobramycin]: 20,
    [Agent.Amikacin]: 100,
    [Agent.Plazomicin]: 50,
  },
  samplingWindows: {
    [NomogramSource.Hartford]: HARTFORD_WINDOW_HR,
    [NomogramSource.BarnesJewish]: [6, 14],
    [NomogramSource.UrbanCraig]: [6, 14],
    [NomogramSource.Rochester]: [6, 14],
  },
};

export { BORDERLINE_BAND_ML_MIN };
